import { animate, style, transition } from '@angular/animations';

export const fadeDownIf = [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(-15px) translateZ(0)' }),
    animate('0.2s ease', style({ opacity: 1, transform: 'translateY(0px) translateZ(0)' })),
  ]),
  transition(':leave', [
    style({ opacity: 1, transform: 'translateY(0px) translateZ(0)' }),
    animate('0.2s ease', style({ opacity: 0, transform: 'translateY(-15px) translateZ(0)' })),
  ]),
];
